export default __webpack_public_path__ + "static/media/DE_classic.0f9b6793.jpg";